import { FC } from 'react'

import { ActivityType } from '@forto-dev/feed-v2-models'
import { FeedItem } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { ActivityFeedItemProps } from './types'

export const ActivityFeedItemGenericAction: FC<ActivityFeedItemProps> = ({ item, status }) => {
  const { translate, translateDate } = useLocalisation()

  switch (item.activity.type) {
    case ActivityType.Accept:
    case ActivityType.Add:
    case ActivityType.Announce:
    case ActivityType.Arrive:
    case ActivityType.Block:
    case ActivityType.Create:
    case ActivityType.Delete:
    case ActivityType.Dislike:
    case ActivityType.Flag:
    case ActivityType.Follow:
    case ActivityType.Ignore:
    case ActivityType.Invite:
    case ActivityType.Join:
    case ActivityType.Leave:
    case ActivityType.Like:
    case ActivityType.Listen:
    case ActivityType.Move:
    case ActivityType.Offer:
    case ActivityType.Question:
    case ActivityType.Reject:
    case ActivityType.Read:
    case ActivityType.Remove:
    case ActivityType.TentativeReject:
    case ActivityType.TentativeAccept:
    case ActivityType.Travel:
    case ActivityType.Undo:
    case ActivityType.Update:
    case ActivityType.View:
    case ActivityType.ChangeContainerYardCutOffDate:
    case ActivityType.UpdatePartnerBookingStatus:
    case ActivityType.UpdateCustomsStatus:
    case ActivityType.ChangeContainerDischarge:
    case ActivityType.ChangeContainerEmptyReturn:
    case ActivityType.ChangeDemDetRate:
    case ActivityType.ChangeDetentionRate:
    case ActivityType.ChangeCombinedDemDetRate:
    case ActivityType.ChangeDemurrageRate:
    case ActivityType.ChangeContainerGateOut:
    case ActivityType.ApproveWorkflow:
    case ActivityType.RejectWorkflow:
    case ActivityType.CreateBooking:
    case ActivityType.CancelBooking:
    case ActivityType.ChangeEstimatedTimeDepartureTS:
    case ActivityType.ChangeArrivalTS:
    case ActivityType.BookingUpdateFeedV1:
    case ActivityType.ChangeOperationManagerFeedV1:
    case ActivityType.ChangeOriginOperationManagerFeedV1:
    case ActivityType.RateUpdateAppliedFeedV1:
    case ActivityType.ShipmentContractUpdatedFeedV1:
    case ActivityType.ReportCreated:
      return (
        <FeedItem
          type="update"
          name={item.activity.actor.fullName || 'Service'}
          action={translate(`feed.list.${item.activity.type}.action`)}
          date={translateDate('feed_date', item.activity.createdAt)}
          suffix={item.activity.actor.type === 'Service' ? translate('feed.suffix.automated') : undefined}
          status={status}
        >
          <a id={`feed-activity-${item.id}`} />
        </FeedItem>
      )
    default:
      return null
  }
}
